import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import CVManager from '../../components/JH/personalJourney/CVManager';
import CoverLetterManager from '../../components/JH/personalJourney/CoverLetterManager';
import JHApi from "../../utils/JHApi"
import { Fields } from '../../components/Fields';
import { FIELD_TYPES, capitalize, showDateTimeFromString } from '../../utils/utils';
import FileWordIcon from 'mdi-material-ui/FileWord'
import EditIcon from '@mui/icons-material/Edit';
//import GoogleDocsIcon from '../../assets/svgs/GoogleDocsIcon';
import HelpIcon from '@mui/icons-material/Help';
import ReactGA from 'react-ga4'

function AttachmentCV (props){
    const CVUrl = props.CVUrl
    const attachmentCVFileName = props.attachmentCVFileName
    const CVUrlUploadTime = props.CVUrlUploadTime

    //style={{color: 'initial', display: 'flex', border: '1px solid #0003', borderRadius: 8, padding: 8, width: 'fit-content', textDecoration: 'none'}}

    return (
        <a target='_blank' rel="noopener noreferrer" href={CVUrl} 
            style={{color: 'initial', border: '1px solid rgba(0, 0, 0, 0.2)', borderRadius: 8, padding: 8, textDecoration: 'none', display: 'inline-block', maxWidth: '100%', overflow: 'hidden'}}>
            <div style={{marginRight:8, float:'left'}}><FileWordIcon color='primary' style={{fontSize: 32}}/></div>
            <div style={{float:'left'}}>
                <Typography>{attachmentCVFileName}</Typography>
                {CVUrlUploadTime&&<Typography color='textSecondary'>{showDateTimeFromString(CVUrlUploadTime, true)}</Typography>}
            </div>
        </a>
    )
}

function ProfileInfoDialog (props){
    const journeyData = props.journeyData || {}
    const userInfo = props.userInfo || {}

    const defNewData = (journeyData.first_name || journeyData.last_name) ? {} : {first_name: userInfo.first_name, last_name: userInfo.last_name}

    const [newData, setNewData] = useState(defNewData);
    const [error, setError] = useState();
    const [disabled, setDisabled] = useState(false);

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else if (journeyData[name] !== undefined){
            return journeyData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeTitle = (titleGroup, titleCategories) => {
        if (getValue('title', '')){
            setNewData({...newData, titleGroup, titleCategories})
        } else {
            setNewData({...newData, title:titleGroup, titleGroup, titleCategories})
        }
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    };

    const handleSaveFields = e => {
        e.preventDefault();

        let paramsToPass = {data:newData}
    
        setDisabled(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            props.setJourneyData(response.personaljourney);
            setDisabled(false)
            handleCloseDialog()
        }, (error) => {
            setError(error)
            setDisabled(false)
        })
    }

    const handleCloseDialog = () => {
        props.handleClose()
    }

    const fields = [
        //{name:'email', label:'Email', inputType:'email', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        //{name:'phone', label:'Phone', inputType:'tel', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'first_name', label:'First name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'last_name', label:'Last name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'titleGroup', label:'Professional Title', type:FIELD_TYPES.TITLE, handleChangeTitle, sm:12, required: true},
        {name:'title', label:'Professional Title (Free Text)', defaultValue: '', hide: (!getValue('titleGroup', '') && !getValue('title', '')) , type:FIELD_TYPES.TEXT, sm:12, required: true},
        //{name:'seniorityLevel', label:'Seniority', defaultValue: '', type:FIELD_TYPES.SELECT, options:SENIORITIES, sm:12}
    ]

    return (
        <form onSubmit={handleSaveFields}>
            <DialogContent dividers>
                {(error)&&<Typography color="error">{error}</Typography>}
                <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
            </DialogContent>
            <DialogActions>
                <Button disabled={disabled} onClick={handleCloseDialog} color="primary" size="small" aria-label="Cancel">
                    Cancel
                </Button>
                <Button
                    disabled={disabled}
                    type="submit"
                    variant="outlined"
                    color="primary"
                    size="small"
                    aria-label='Save'
                >
                    Save
                </Button>
            </DialogActions>
        </form>
    )
}

export default function CLCVList(props) {
    const open = props.open || false
    const disabled = props.disabled || false;
    const isActiveJHUser = props.isActiveJHUser || false

    const journeyData = props.journeyData || {} 
    const userInfo = props.userInfo || {}
    const job = props.job || {}

    const [showErrors, setShowErrors] = useState(false);

    const defEditSection = (journeyData.title && journeyData.first_name && journeyData.last_name) ? undefined : 'title'
    const [editSection, setEditSection] = useState(defEditSection);

    const applyPickedCVIndex = (journeyData.resumes||[]).findIndex(resume => (resume.applyPicked && !resume.isDeleted));
    const applyPickedCLIndex = (journeyData.coverLetters||[]).findIndex(coverLetter => (coverLetter.applyPicked && !coverLetter.isDeleted));

    const haveCoverLetters = (journeyData.coverLetters||[]).filter(coverLetter=>(!coverLetter.isDeleted)).length > 0
    const haveCV = (journeyData.resumes||[]).filter(resume=>(!resume.isDeleted)).length > 0

    const selectedCV = (journeyData.resumes||[])[applyPickedCVIndex] || {}
    const selectedCL = (journeyData.coverLetters||[])[applyPickedCLIndex] || {}

    const getValue = (name, defaultValue) => {
        if (journeyData[name] !== undefined){
            return journeyData[name]
        } else {
            return defaultValue
        }
    }

    const [isLoading, setIsLoading] = useState(false);

    const handleSaveData = (data, onSuccess, onError) => {
        let paramsToPass = {data}
    
        setIsLoading(true)

        JHApi.updatePersonalJourneyData(paramsToPass,(response)=>{
            props.setJourneyData(response.personaljourney);
            setIsLoading(false)
            if (onSuccess){
                onSuccess(response)
            }
        }, (error) => {
            setIsLoading(false)
            //setIsError(true)
            if (onError){
                onError(error)
            }
        })
    }

    const preServerCall = () => {
        setIsLoading(true)
    }

    const postServerCall = (error, response) => {
        if(error){
            props.showMessageDialog('Error', error)
        } else {
            if(response && response.personaljourney){
                props.setJourneyData(response.personaljourney);
            }
        }

        setIsLoading(false)
    }

    const propsToPass = {
        isLoading, handleSaveData, preServerCall, postServerCall
    }

    const handleApply = e => {
        const canApply = (
            applyPickedCVIndex !== -1 && applyPickedCLIndex !== -1 && selectedCV.link && selectedCV.CVUrl &&
            getValue('title', '') && getValue('first_name', '') && getValue('last_name', '')
        )

        if (canApply){
            ReactGA.event({category: `Journey${isActiveJHUser?'_client':''}`, action: `job_apply_applied`, label:window.VIEW_TYPE})
            props.onClose()
            props.handleApply()
        } else {
            setShowErrors(true)
        }
    }

    const handleClose = () => {
        ReactGA.event({category: `Journey${isActiveJHUser?'_client':''}`, action: `job_apply_close`, label:window.VIEW_TYPE})
        setEditSection()
        props.onClose()
    }

    let emailTitle = 'Add info for email title'
    let CVFileName = 'Add info for CV file name'
    let attachmentCVFileName = 'Add info for CV file name'

    if (journeyData.title && journeyData.first_name && journeyData.last_name){
        emailTitle = journeyData.title + ' CV - ' + capitalize(journeyData.first_name) + ' ' + journeyData.last_name[0].toUpperCase()
        emailTitle = emailTitle.replace(/[,]/mgi, " ");
        emailTitle = emailTitle.replace(/  +/mgi, " ");
        CVFileName = emailTitle
        // eslint-disable-next-line no-useless-escape
        CVFileName = CVFileName.replace(/[\/|\\]/mgi, " ");
        CVFileName = CVFileName.replace(/  +/mgi, " ");
        attachmentCVFileName = CVFileName.replace(/[ ]/mgi, "_");
        attachmentCVFileName = attachmentCVFileName + '.' + selectedCV.CVExtension
    }

    const view = (window.innerWidth <= 768)?'MOBILE':'DESKTOP'
    
    return (
        <Dialog onClose={handleClose} open={open} maxWidth='lg' fullScreen={view==='MOBILE'}>
            <DialogTitle>
                <Typography  style={{fontSize: 20}}><strong>Apply for {job.title}</strong></Typography>
                {job.company&&<Typography color='textSecondary'>{job.company}</Typography>}
            </DialogTitle>
            {(editSection===undefined)?<>
                <DialogContent dividers>
                    {(view==='DESKTOP')&&<><div>
                        <Typography style={{fontSize: 18}}><strong>Aplication details</strong></Typography>
                        <Typography>Job Title: <strong>{job.title}</strong></Typography>
                        {job.company&&<Typography>Company: <strong>{job.company}</strong></Typography>}
                    </div>
                    <Divider style={{margin: '16px 0'}}/></>}
                    <Typography><strong>Title</strong></Typography>
                    <div dir="auto" style={{fontFamily: `Arial, "sans-serif"`, padding: 8, border: '1px solid', borderRadius: 5, marginBottom: 8, borderColor: (showErrors && (!journeyData.title || !journeyData.first_name || !journeyData.last_name)) ? '#f44336' : '#00000033'}}>
                        <Typography style={{display: 'flex', alignItems: 'flex-start'}}>{emailTitle}<IconButton disabled={editSection!==undefined} onClick={()=>setEditSection('title')} style={{marginLeft:8}} color='primary' size='small'><EditIcon style={{fontSize: 16}}/></IconButton></Typography>
                    </div>

                    <Typography><strong>Application</strong></Typography>
                    <div style={{textAlign:'right', padding: 8, border: '1px solid #0003', borderRadius: 5, marginBottom: 8}}>
                        <div dir="rtl" style={{display: 'flex', fontFamily: `'Arial','sans-serif'`}}>
                            {selectedCL.content?<>
                                <div dangerouslySetInnerHTML={{__html: selectedCL.content || ''}} />
                                <div style={{display: "flex", alignItems: 'center'}}>
                                    <div>
                                        <IconButton
                                            disabled={editSection!==undefined}
                                            onClick={()=>setEditSection('coverLetter')}
                                            style={{marginRight:8}}
                                            color='primary'
                                            size="large"><EditIcon style={{fontSize: 16}}/></IconButton>
                                    </div>
                                </div>
                            </>:<div style={{padding: 36, border: '2px dashed', borderRadius: 5, backgroundColor: '#f1f2f7', width: '100%', textAlign: 'center', margin: 5, borderColor: showErrors ? '#f44336' : '#e5e4e9'}}>
                                <Typography style={{marginBottom: 8, direction: 'ltr', fontSize: 17}}>A great cover letter can be the difference between getting noticed and getting ignored.</Typography>
                                {showErrors&&<Typography style={{marginBottom: 8}} color='error'>Cover Letter missing</Typography>}
                                <Button style={{textTransform: 'capitalize'}} color='primary' variant='contained' size='small' onClick={()=>setEditSection('coverLetter')}>{haveCoverLetters? 'Choose' : 'Compose'} Cover Letter</Button>
                                {!haveCoverLetters&&<Typography color='textSecondary' style={{marginTop: 8}}>Can be used for future applications</Typography>}
                            </div>
                            }
                        </div>
                        <div dir="rtl" style={{marginTop: 5, fontFamily: `'Arial','sans-serif'`, fontSize: 14, display: 'flex'}}>
                            {selectedCV.link?<p>
                                מצורפים קורות החיים<br />
                                <a href={selectedCV.link}>{CVFileName}</a> 
                                <IconButton disabled={editSection!==undefined} onClick={()=>setEditSection('CV')} style={{marginRight:8}} color='primary' size='small'><EditIcon style={{fontSize: 16}}/></IconButton>
                            </p>:<div style={{padding: 36, border: '2px dashed', borderRadius: 5, backgroundColor: '#f1f2f7', width: '100%', textAlign: 'center', margin: 5, borderColor: showErrors ? '#f44336' : '#e5e4e9'}}>
                                {/*<div style={{marginTop: 16, marginRight: 16}}>
                                    <GoogleDocsIcon/>
                                </div>*/}
                                {showErrors&&<Typography style={{marginBottom: 8}} color='error'>CV missing</Typography>}
                                <Button style={{textTransform: 'capitalize'}} color='primary' variant='contained' size='small' onClick={()=>setEditSection('CV')}>
                                    {haveCV? 'Choose' : 'Add'} CV
                                </Button>
                                {!haveCV&&<Typography color='textSecondary' style={{marginTop: 8}}>Can be used for future applications</Typography>}
                            </div>}

                            {(selectedCV.link && selectedCL.content)&&<div dir="rtl" style={{marginTop: 25, fontSize: 14, fontFamily: `'Arial','sans-serif'`}}>
                                <p>פנייה זו התקבלה למשרה: {job.title}</p>

                                <p style={{marginBottom: 0}}>לעריכת המשרה - <span style={{color: '#0000ee', textDecorationLine: 'underline'}}>לחץ כאן</span></p>
                                <p style={{marginBottom: 0}}>להסרת הדיוור - <span style={{color: '#0000ee', textDecorationLine: 'underline'}}>לחץ כאן</span></p>

                                <p>זהו מייל אוטומטי, אין להשיב להודעה זו.</p>
                                <p style={{marginBottom: 0}}>מייל זה נשלח ל email@email.com</p>
                            </div>}
                        </div>
                    </div>

                    {(selectedCV.CVUrl)&&<div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Typography><strong>Attachment</strong></Typography>
                            <IconButton
                                disabled={editSection!==undefined}
                                onClick={()=>setEditSection('attachedCV')}
                                color='primary'
                                size="large"><EditIcon style={{fontSize: 16}}/></IconButton>
                        </div>
                        <Typography color='textSecondary'>We recommend reviewing the file before applying</Typography>
                        <AttachmentCV CVUrl={selectedCV.CVUrl} attachmentCVFileName={attachmentCVFileName} CVUrlUploadTime={selectedCV.CVUrlUploadTime}/>
                    </div>}
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={props.handleFeedback} variant="outlined" color="primary" size="small" aria-label='Help'>
                        <HelpIcon style={{marginRight: 8}}/>
                        Help
                    </Button>
                    <div style={{flex:1}}></div>
                    <Button disabled={disabled} onClick={handleApply} variant="outlined" color="primary" size="small" aria-label='Apply'>
                        Apply
                    </Button>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Cancel">
                        Close
                    </Button>
                </DialogActions>
            </>:<>
                {(editSection==='title')?<>
                    <ProfileInfoDialog userInfo={userInfo} journeyData={journeyData} handleClose={()=>setEditSection()} setJourneyData={props.setJourneyData}/>
                </>:<>
                    <DialogContent>
                        {(editSection==='coverLetter')&&<div style={{margin: '16px 0'}}>
                            <CoverLetterManager {...props} {...propsToPass} handlaeAfterSelect={()=>setEditSection()} isActiveJHUser={isActiveJHUser}/>
                        </div>}
                        {(editSection==='CV'||editSection==='attachedCV')&&<div style={{margin: '16px 0'}}>
                            {(selectedCV.CVUrl&&editSection==='attachedCV')&&<div>
                                <Typography><strong>Attachment</strong></Typography>
                                <AttachmentCV CVUrl={selectedCV.CVUrl} attachmentCVFileName={attachmentCVFileName} CVUrlUploadTime={selectedCV.CVUrlUploadTime}/>
                            </div>}
                            <CVManager {...props} {...propsToPass} applyPickedCVIndex={applyPickedCVIndex} editSection={editSection} handlaeAfterSelect={()=>setEditSection()} isActiveJHUser={isActiveJHUser}/>
                        </div>}
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={disabled} onClick={()=>setEditSection()} color="primary" size="small" aria-label="Done">
                            Done
                        </Button>
                    </DialogActions>
                </>}
            </>}
        </Dialog>
    );
}